import { OptionsSeatControlNames } from '@shared/components/delivery-cargo/components/delivery-cargo-places/delivery-cargo-places.enums';

export const SPECIAL_CARGO_UNAVAILABLE_TOOLTIP =
  'Параметри відправлення не відповідають умовам вибору: Вага (об’ємна та фактична) від 0.1 до 30 кг (включно); Сторони: Довжина, Ширина, Висота  <= 120 см';

export const SPECIAL_CARGO_HINT_TOOLTIP =
  'Встановіть відмітку, якщо дане відправлення (місце): не запаковано в коробку або гофрокартон з пласкою основою та не є пласким пакетом з одягом; відправляється та доставляється з/до вантажних відділень, адреси або пункту приймання-видачі';

export const VOLUMETRIC_WEIGHT_TOOLTIP =
  'Об’ємна вага розраховується за формулою (Довжина × Ширина × Висота, см) / 4000 та порівнюється з фактичною вагою. Більший показник використовується в розрахунках вартості перевезення.';

export const WEIGHT_INPUT_CONFIG = {
  controlName: OptionsSeatControlNames.Weight,
  placeholder: 'Вага',
  maxValue: 1000,
  minValue: 0.1,
  allowFloat: true,
  digitsAfterDot: 3,
  unit: 'кг',
};

export const VOLUMETRIC_LENGTH_INPUT_CONFIG = {
  controlName: OptionsSeatControlNames.VolumetricLength,
  placeholder: 'Довжина',
  maxValue: 999,
  minValue: 0.1,
  allowFloat: false,
  maxInputLength: 3,
  unit: 'см',
};

export const VOLUMETRIC_HEIGHT_INPUT_CONFIG = {
  controlName: OptionsSeatControlNames.VolumetricHeight,
  placeholder: 'Висота',
  maxValue: 999,
  minValue: 0.1,
  allowFloat: false,
  maxInputLength: 3,
  unit: 'см',
};

export const VOLUMETRIC_WIDTH_INPUT_CONFIG = {
  controlName: OptionsSeatControlNames.VolumetricWidth,
  placeholder: 'Ширина',
  maxValue: 999,
  minValue: 0.1,
  allowFloat: false,
  maxInputLength: 3,
  unit: 'см',
};

export const PLACE_COST_INPUT_CONFIG = {
  controlName: OptionsSeatControlNames.Cost,
  placeholder: 'Оціночна вартість',
  maxValue: 5000000,
  minValue: 0.1,
  allowFloat: true,
  digitsAfterDot: 2,
  maxInputLength: 7,
  unit: 'грн',
};
